import React from 'react'
import CustomCards from './CustomCard'
import { selectCommission } from './reports.selectors'
import { useSelector } from 'react-redux'
import { CARD_TITLE, COMMISSION_TYPE } from './reports.constants'
import BusyIndicator, { REGIONS } from '../../widgets/busyIndicator'
import { isEmpty } from 'lodash'
import DashboardCard from '../../components/cards/DashboardCard'

const Commission = () => {
	const commission = useSelector(selectCommission)

	const commissionCards = [
		{
			title: 'Total Expected Amount',
			currentValue: commission?.totalCommission?.expectedTotalValue,
			commissionType: COMMISSION_TYPE.Total,
			isCurrency: true,
		},
		{
			title: 'Total Expected Commission',
			currentValue: commission?.totalCommission?.expectedTotalCommission,
			commissionType: COMMISSION_TYPE.Total,
			isCurrency: true,
		},
		{
			title: 'Total Actual Amount',
			currentValue: commission?.totalCommission?.actualTotalValue,
			commissionType: COMMISSION_TYPE.Total,
			isCurrency: true,
		},
		{
			title: 'Total Actual Commission',
			currentValue: commission?.totalCommission?.actualTotalCommission,
			commissionType: COMMISSION_TYPE.Total,
			isCurrency: true,
		},
		{
			title: 'New Deals Expected Amount',
			currentValue: commission?.newCommission?.expectedTotalValue,
			commissionType: COMMISSION_TYPE.New,
			isCurrency: true,
		},
		{
			title: 'New Deals Expected Commission',
			currentValue: commission?.newCommission?.expectedTotalCommission,
			commissionType: COMMISSION_TYPE.New,
			isCurrency: true,
		},
		{
			title: 'New Deals Actual Amount',
			currentValue: commission?.newCommission?.actualTotalValue,
			commissionType: COMMISSION_TYPE.New,
			isCurrency: true,
		},
		{
			title: 'New Deals Actual Commission',
			currentValue: commission?.newCommission?.actualTotalCommission,
			commissionType: COMMISSION_TYPE.New,
			isCurrency: true,
		},
		{
			title: 'Renewed Deals Expected Amount',
			currentValue: commission?.renewedCommission?.expectedTotalValue,
			commissionType: COMMISSION_TYPE.Renewed,
			isCurrency: true,
		},
		{
			title: 'Renewed Deals Expected Commission',
			currentValue: commission?.renewedCommission?.expectedTotalCommission,
			commissionType: COMMISSION_TYPE.Renewed,
			isCurrency: true,
		},
		{
			title: 'Renewed Deals Actual Amount',
			currentValue: commission?.renewedCommission?.actualTotalValue,
			commissionType: COMMISSION_TYPE.Renewed,
			isCurrency: true,
		},
		{
			title: 'Renewed Deals Actual Commission',
			currentValue: commission?.renewedCommission?.actualTotalCommission,
			commissionType: COMMISSION_TYPE.Renewed,
			isCurrency: true,
		},
		{
			title: 'Updated Deals Expected Amount',
			currentValue: commission?.updatedCommission?.expectedTotalValue,
			commissionType: COMMISSION_TYPE.Updated,
			isCurrency: true,
		},
		{
			title: 'Updated Deals Expected Commission',
			currentValue: commission?.updatedCommission?.expectedTotalCommission,
			commissionType: COMMISSION_TYPE.Updated,
			isCurrency: true,
		},
		{
			title: 'Updated Deals Actual Amount',
			currentValue: commission?.updatedCommission?.actualTotalValue,
			commissionType: COMMISSION_TYPE.Updated,
			isCurrency: true,
		},
		{
			title: 'Updated Deals Actual Commission',
			currentValue: commission?.updatedCommission?.actualTotalCommission,
			commissionType: COMMISSION_TYPE.Updated,
			isCurrency: true,
		},
		{
			title: 'Awaiting Payment Expected Amount',
			currentValue: commission?.awaitingPaymentCommission?.expectedTotalValue,
			commissionType: COMMISSION_TYPE.AwaitingPayment,
			isCurrency: true,
		},
		{
			title: 'Awaiting Payment Expected Commission',
			currentValue:
				commission?.awaitingPaymentCommission?.expectedTotalCommission,
			commissionType: COMMISSION_TYPE.AwaitingPayment,
			isCurrency: true,
		},
	]

	return (
		<DashboardCard title='Billing'>
			<BusyIndicator region={REGIONS.FETCH_COMMISSIONS}>
				<div className='grid w-full gap-3 items-stretch grid-cols-2 md:grid-cols-3 lg:grid-cols-9'>
				{!isEmpty(commission) && (
					<CustomCards
						cards={commissionCards}
						cardTitle={CARD_TITLE.COMMISSION}
					/>
				)}
				</div>
			</BusyIndicator>
		</DashboardCard>
	)
}

export default Commission
